import SatisfiesTickIcon from "../../../../../svg/satisfiesTickIcon";
import { AnswerAssessmentVerdict } from "../../types";

/**
 * Props for the verdict status icon.
 */
interface VerdictIconProps {
  /** Assessment verdict that determines which icon to show. */
  verdict: AnswerAssessmentVerdict;
}

/**
 * Status icon for an assessment verdict (checkmark for Satisfies).
 *
 * @param props.verdict - Assessment verdict
 */
const VerdictIcon = (props: VerdictIconProps) => {
  if (props.verdict === "SATISFIES") {
    return <SatisfiesTickIcon width="20" height="20" />;
  }

  if (props.verdict === "VIOLATES") {
    return (
      <span className="flex h-5 w-5 items-center justify-center rounded-full border border-tertiaryRed-600 text-x-tiny font-bold text-tertiaryRed-600">
        ✕
      </span>
    );
  }

  return (
    <span className="flex h-5 w-5 items-center justify-center rounded-full border border-secondaryYellow-2 text-x-tiny font-bold text-secondaryYellow-2">
      !
    </span>
  );
};

export default VerdictIcon;
